module.exports = __webpack_public_path__ + "static/avatar-b020c3c064e7a44fc02fea5e826adbb4.jpg";